import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PagesService } from '../pages.service';
import { MatDialog } from '@angular/material/dialog';
import { XpcnPreviewDialogComponent } from '../shared/xpcn-preview-dialog/xpcn-preview-dialog.component';
import { AlertService } from 'src/app/shared/services/alert.service';
import { DatePipe } from '@angular/common';
import { DownloadExcelService } from 'src/app/services/download-excel.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';

@Component({
  selector: 'app-delivered',
  templateUrl: './delivered.component.html',
  styleUrls: ['./delivered.component.scss']
})
export class DeliveredComponent implements OnInit {
  filterToggle: boolean = true;
  CustomDate: boolean = false;
  filterObject: FormGroup;
  selectedDateFilter: string = 'MTD';
  filterBy = '';
  podDocUrls: any;
  keyword = '';
  OrderList = [];
  excelData: any[];
  public pageSize = 5;
  public currentPage = 0;
  public totalSize = 0;
  endIndex: number;
  startIndex = 1;
  keywordDate = '';
  dateFilter = '';
  filterForm: FormGroup;
  ifDownloading: boolean = false;
  fullOrderList: any[] = [];
  constructor(private fb: FormBuilder, public dialog: MatDialog,    public _downloadExcelService: DownloadExcelService,
    private _pageService: PagesService,
    public alertService: AlertService,  private _datePipe: DatePipe,)
   { this.filterObject = this.fb.group({
    FilterType: new FormControl(''),
    FromDate: new FormControl(''),
    ToDate: new FormControl(''),
    StartIndex: new FormControl(''),
    GridSize: new FormControl(''),
    BranchId: new FormControl(''),
    Keyword :new FormControl(''),
    customerfilt :new FormControl(''),
    consignorfilt :new FormControl(''),
    xpcnfilt :new FormControl(''),
    polrfilt :new FormControl(''),
    bookingfilt :new FormControl(''),
    CustomerId: new FormControl('')
  })
  this.filterForm = this.fb.group({
    OrderBy: new FormControl(""),
    StartIndex: new FormControl(""),
    EndIndex: new FormControl(""),
    filterBy: new FormControl(""),
    Keyword :new FormControl(''),
    customerfilt :new FormControl(''),
    consignorfilt :new FormControl(''),
    xpcnfilt :new FormControl(''),
    polrfilt :new FormControl(''),
    bookingfilt :new FormControl(''),
    FromDate: new FormControl(""),
    ToDate: new FormControl(""),
    datefilterType: new FormControl("")

  });
  this.filterForm.controls['StartIndex'].setValue(this.startIndex);
  this.filterForm.controls['EndIndex'].setValue(this.pageSize);
}

  ngOnInit(): void {
    this.filterForm.controls["datefilterType"].setValue('MTD');

    this.getData();
  }

isDownloading = false;
progress = 0;

async downloadMergedPDF() {
  if (this.podDocUrls.length === 0) {
    console.warn("No POD URLs found.");
    return;
  }

  this.isDownloading = true; 
  this.progress = 0; 

  console.log("Download started...");
  const pdf = new jsPDF();
  let isFirstPage = true;
  const totalFiles = this.podDocUrls.length;
  
  for (let i = 0; i < totalFiles; i++) {
    const url = this.podDocUrls[i];
    if (!url) continue;

    let imgData;
    if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png')) {
      imgData = await this.loadImage(url);
    } else {
      imgData = await this.capturePDFAsImage(url);
    }

    if (imgData) {
      if (!isFirstPage) pdf.addPage();
      pdf.addImage(imgData, 'JPEG', 10, 10, 190, 280);
      isFirstPage = false;
    }

    this.progress = Math.floor(((i + 1) / totalFiles) * 100); 
  }

  console.log("Download finished. Saving PDF...");
  pdf.save('merged_pdfs.pdf');
  console.log("PDF saved successfully.");

  this.isDownloading = false; 
}

  
  

  async loadImage(url: string): Promise<string | null> {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/jpeg'));
        } else {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
    });
  }

  async capturePDFAsImage(pdfUrl: string): Promise<string | null> {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.left = '-9999px';
      iframe.style.width = '800px';
      iframe.style.height = '1000px';
      iframe.src = pdfUrl;

      document.body.appendChild(iframe);

      iframe.onload = async () => {
        setTimeout(async () => {
          try {
            const canvas = await html2canvas(iframe.contentDocument!.body);
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            resolve(imgData);
          } catch (error) {
            console.error('Error capturing PDF:', error);
            resolve(null);
          }
          document.body.removeChild(iframe);
        }, 2000);
      };
    });
  }

  getData() {
    // const originalStartIndex = this.filterForm.controls['StartIndex'].value;
    // const originalEndIndex = this.filterForm.controls['EndIndex'].value;
  
    this.filterForm.controls['StartIndex'].setValue(1);
    this.filterForm.controls['EndIndex'].setValue(this.totalSize || 1000); 
  
    this._pageService.getdelivereddata(this.filterForm.value).subscribe((res) => {
      // const fullOrderList = res["Data"] || [];
      this.OrderList = res["Data"];
      this.podDocUrls = this.OrderList.map(order => order.PodDocUrl);
      // console.log("All PodDocUrls:", this.podDocUrls);
  
      // this.filterForm.controls['StartIndex'].setValue(originalStartIndex);
      // this.filterForm.controls['EndIndex'].setValue(originalEndIndex);
  
      // this._pageService.getdelivereddata(this.filterForm.value).subscribe((paginatedRes) => {
        this.totalSize = this.OrderList?.[0]?.TotalCount || 0;
      // });
      this.paginateData();
    });
  }
  
  paginateData() {
    if (!this.OrderList || this.OrderList.length === 0) {
      this.fullOrderList = [];
      return;
    }

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.fullOrderList = this.OrderList.slice(start, end);
  }
  
  public handlePage(e: any, isReset = false) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    if (this.currentPage == 0) {
      this.startIndex = 1;
    } else {
      this.startIndex = (this.currentPage * this.pageSize) + 1;
    }
    this.filterForm.controls['StartIndex'].setValue(this.startIndex);
    this.filterForm.controls['EndIndex'].setValue(this.pageSize);
    this.getData();
  }
  
  openLCLXPCNPreview(XPCNID) {
    this.dialog.open(XpcnPreviewDialogComponent, {
      data: {
        xpcn: {
          XPCNId:XPCNID,
          IsFinalized : true
        }
      },
      height: 'auto',
      width: '900px',
      autoFocus: false
    });
  }
  
  clear() {
    this.startIndex = 1;
    this.pageSize = 5;
    this.currentPage = 0;
    this.totalSize = 0;
    this.filterBy = '';
    this.keyword = null;
    this.keywordDate = null;
    this.filterForm.controls['filterBy'].setValue(null);
    this.filterForm.controls['Keyword'].setValue(null);
    this.filterForm.controls["StartIndex"].setValue(this.startIndex);
    this.filterForm.controls["EndIndex"].setValue(this.pageSize);
    this.getData();
  }
  filter() {
    if (this.filterBy != '' && this.filterBy != null) {
      this.filterForm.controls['filterBy'].setValue(this.filterBy);
      if (this.filterBy != 'asndate' && this.filterBy != 'update' && this.filterBy != 'xpcndate') {
        if (this.keyword.trim() != '' && this.keyword != null) {
          this.filterForm.controls['Keyword'].setValue(this.keyword.trim());
        } else {
          this.alertService.createAlert("Please enter keyword", 0);
          return;
        }
        this.keywordDate = null;
      } else {
        this.keyword = null;
        if (this.keywordDate != '' && this.keywordDate != null) {
          this.filterForm.controls['KeywordDate'].setValue(this._datePipe.transform(this.keywordDate, 'yyyy-MM-dd'));
        } else {
          this.alertService.createAlert("Please select date", 0);
          return;
        }
      }
      this.getData();
    } else {
      this.alertService.createAlert("Please select filter by", 0);
      return;
    }
  }
  fromDate
  toDate
  dateFilterChanged(type) {

    this.filterForm.controls["datefilterType"].setValue(null);

    this.filterForm.controls["FromDate"].setValue(null);
    this.filterForm.controls["ToDate"].setValue(null);

    this.dateFilter = type;
    this.selectedDateFilter = type;
    this.filterForm.controls["datefilterType"].setValue(this.dateFilter);

    if (type == 'Dates') {
      if (new Date(this._datePipe.transform(this.fromDate, 'yyyy-MM-dd')) > new Date(this._datePipe.transform(this.toDate, 'yyyy-MM-dd'))) {
        this.alertService.createAlert('From date cannot be grater than to date', 0);
      } else {
        this.filterForm.controls["FromDate"].setValue(new Date(this._datePipe.transform(this.fromDate, 'yyyy-MM-dd')));
        this.filterForm.controls["ToDate"].setValue(new Date(this._datePipe.transform(this.toDate, 'yyyy-MM-dd')));
      }
    } else {
      this.filterForm.controls["FromDate"].setValue(null);
      this.filterForm.controls["ToDate"].setValue(null);

      this.fromDate = null;
      this.toDate = null;
    }

    this.getData();

  }
  
  datefilterclear() {
    this.fromDate = null;
    this.toDate = null;
    this.filterForm.controls["datefilterType"].setValue('MTD');
    this.filterForm.controls["FromDate"].setValue(null);
    this.filterForm.controls["ToDate"].setValue(null);

    this.getData();
  }

  search() {
    this.getData()
    console.log('Search button clicked');
  }

  public exportAsExcel() {
    this.excelData = [];
    let list = [];

    this.filterForm.controls['EndIndex'].setValue(this.totalSize);
    this._pageService.getdelivereddata(this.filterForm.value).subscribe(data => {
      if (data != null) {
        list = data['Data'];
        if (list.length > 0) {
          list.forEach(element => {
            this.excelData.push({
              'Booking Date': this._datePipe.transform(element['BookingDate'], 'dd-MM-y'),
              'Customer Doc/LR/PO': element['loding_doc'],
              'XP Booking Id': element['BookingIdCode'],
              'Customer Name': element['Customer'],
              'Consignor Name': element['consignor'],
              'Customer Pick-up Location': element['PickUpAddress'],
              'XPCN No': element['XPCNCode'],
              'XPCN Generation Date': this._datePipe.transform(element['XPCNDate'], 'dd-MM-y'),
              'No of Packages': element['boxescount'],
              'Consignee Name': element['consignee'],
              'Consignee Location':element['consignee_location'],
              'Picked Date ':this._datePipe.transform(element['PickedDate'], 'dd-MM-y'),
              'Delivered Date ':this._datePipe.transform(element['DeliveryDate'], 'dd-MM-y'),
              'Delivery Days':element['DeliveryDays'],
              'POD URL':element['PodDocUrl'],
              'Remarks':element['pod_remark']

            })
          });
        }
        else {
          this.excelData.push({
            'Booking Date': '-',
            'Customer Doc/LR/PO': '-',
            'XP Booking Id':'-',
            'Customer Name': '-',
            'Consignor Name': '-',
            'Customer Pick-up Location': '-',
            'XPCN No' : '-',
            'XPCN Generation Date': '-',
            'No of Packages':'-',
              'Consignee Name': '-',
              'Consignee Location':'-',
              'Picked Date ':'-',
              'Delivered Date ':'-',
              'Delivery Days':'-',
              'POD URL':'-',
              'Remarks':'-'

          })
        }
        this._downloadExcelService.exportAsExcelFile(this.excelData, 'Delivered');
      }
    })
  }

  async downloadZipPODs() {
    if (this.podDocUrls.length === 0) {
      console.warn("No POD URLs found.");
      return;
    }
  
    this.ifDownloading = true;
    this.progress = 0;
    const zip = new JSZip();
    const totalFiles = this.podDocUrls.length;
  
    for (let i = 0; i < totalFiles; i++) {
      const url = this.podDocUrls[i];
      if (!url) continue;
      let imgData: string | null;
      if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png')) {
        imgData = await this.loadImage(url);
      } else {
        imgData = await this.capturePDFAsImage(url);
      }
  
      if (imgData) {
        const base64Data = imgData.split(',')[1];
        const extMatch = imgData.match(/^data:image\/(png|jpeg)/);
        const extension = extMatch ? (extMatch[1] === 'jpeg' ? 'jpg' : extMatch[1]) : 'jpg';
  
        const fileName = url.split('/').pop()?.split('?')[0] || `POD_${i + 1}.${extension}`;
  
        zip.file(fileName, base64Data, { base64: true });
      }
      this.progress = Math.floor(((i + 1) / totalFiles) * 100);
    }
      zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'PODs.zip');
      this.ifDownloading = false;
      this.progress = 0;
    }).catch(err => {
      console.error("Error creating ZIP file:", err);
      this.ifDownloading = false;
      this.progress = 0;
    });
  }
  
  
}
